 import api from "../../api.js";

 export async function fetchSuppliers(params = {}) {
   const { departmentid } = params;
   const res = await api.get("/api/suppliers", { params: { departmentid } });
   return res.data?.data || [];
 }

export async function createSupplier(payload) {
  const res = await api.post("/api/suppliers", payload);
  return res.data?.data;
}

export async function updateSupplier(suppliercode, payload) {
  const res = await api.put(`/api/suppliers/${encodeURIComponent(suppliercode)}`, payload);
  return res.data?.data;
}

// Upload via server (multipart), returns URL or key
export async function uploadSupplierDoc(suppliercode, file) {
  const form = new FormData();
  form.append("suppliercode", suppliercode);
  form.append("file", file);
  const res = await api.post(`/api/suppliers/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const data = res.data || {};
  return data.viewUrl || data.location || data.key || null;
}
